import { useCallback, useEffect, useState } from "react";
import * as Scrivito from "scrivito";
import type { NavigateToCustomProductProps } from "interfaces/product/product.types";
import { useIsSameProj } from "stores/globalStore";
import { useProject } from "stores/project";

export const useNavigateToCustomProduct = () => {
  const project = useProject();
  const isSameProj = useIsSameProj();

  const [customItemObj, setCustomItemObj] = useState<Scrivito.Obj | null>(null);

  useEffect(() => {
    Scrivito.load(() => {
      const basePath = isSameProj ? "same/en/" : "/website/de/";

      return Scrivito.Obj.where("_objClass", "equals", "CustomProductItem")
        .and("_path", "startsWith", basePath)
        .first();
    }).then((obj) => setCustomItemObj(obj));
  }, [isSameProj]);

  const navigateToCustomProduct = useCallback(
    (customdata: NavigateToCustomProductProps) => {
      if (!project?.id) {
        console.error(
          "Project ID is missing. Cannot navigate to custom product.",
        );
        return;
      }
      if (!customItemObj) {
        return;
      }

      Scrivito.navigateTo(() => customItemObj, {
        params: {
          ...customdata,
          projectId: project.id,
        } as unknown as Record<string, string | string[] | null>,
      });
    },
    [customItemObj, project],
  );

  return navigateToCustomProduct;
};
